import { useIsMobile } from 'app-ui/utilities';

import { isNavigationDrawerCollapsedState } from '@/ui/layout/navigation-drawer/states/isNavigationDrawerCollapsedState';
import { useAtomStateValue } from '@/ui/utilities/state/jotai/hooks/useAtomStateValue';

// On mobile the drawer is an overlay and always shows its labels, whatever
// was chosen on a larger screen.
export const useIsNavigationDrawerCollapsed = () => {
  const isNavigationDrawerCollapsed = useAtomStateValue(
    isNavigationDrawerCollapsedState,
  );
  const isMobile = useIsMobile();

  return isNavigationDrawerCollapsed && !isMobile;
};
